import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import AppShell from "./components/AppShell";
import { AuthGuard } from "./components/PrivateRoute";

import Home from "./pages-app/page";
import SearchPage from "./pages-app/search/page";
import MovieDetailPage from "./pages-app/[type]/[id]/[slug]/page";
import MoviesArchivePage from "./pages-app/(archive)/movies/page";
import SeriesArchivePage from "./pages-app/(archive)/series/page";
import GenreArchivePage from "./pages-app/(archive)/genre/[slug]/page";
import CountryArchivePage from "./pages-app/(archive)/country/[slug]/page";
import LanguageArchivePage from "./pages-app/(archive)/language/[slug]/page";
import NetworkArchivePage from "./pages-app/(archive)/network/[slug]/page";
import ReleaseArchivePage from "./pages-app/(archive)/release/[slug]/page";
import ActorsPage from "./pages-app/(agents)/actors/page";
import DirectorsPage from "./pages-app/(agents)/directors/page";
import ActorDetailPage from "./pages-app/(agents)/actors/[slug]/page";
import DirectorDetailPage from "./pages-app/(agents)/directors/[slug]/page";
import ListsPage from "./pages-app/lists/page";
import ListDetailPage from "./pages-app/lists/[id]/page";
import AuthPage from "./pages-app/auth/page";
import ForgotPasswordPage from "./pages-app/auth/forgot-password/page";
import AuthLayout from "./pages-app/auth/layout";
import PlayerPage from "./pages-app/player/[id]/page";
import GamePage from "./pages-app/game/[id]/page";
import CompetitionPage from "./pages-app/competition/page";
import ProfileLayout from "./pages-app/profile/layout";
import ProfileDashboard from "./pages-app/profile/page";
import ProfileEdit from "./pages-app/profile/edit/page";
import ProfileFavorites from "./pages-app/profile/favorites/page";
import ProfileWatchList from "./pages-app/profile/watch-list/page";
import ProfileDevices from "./pages-app/profile/devices/page";
import ProfileWallet from "./pages-app/profile/wallet/page";
import ProfileWalletDetail from "./pages-app/profile/wallet/[id]/page";
import ProfileSubscription from "./pages-app/profile/subscription/page";
import ProfileSubscriptionPay from "./pages-app/profile/subscription/pay/page";
import ProfileSubscriptionDetail from "./pages-app/profile/subscription/[id]/page";
import ProfileLists from "./pages-app/profile/lists/page";
import ProfileListsCreate from "./pages-app/profile/lists/create/page";
import ProfileListDetail from "./pages-app/profile/lists/[id]/page";
import ProfileListEdit from "./pages-app/profile/lists/[id]/edit/page";
import ProfileTickets from "./pages-app/profile/tickets/page";
import ProfileTicketsCreate from "./pages-app/profile/tickets/create/page";
import ProfileTicketDetail from "./pages-app/profile/tickets/[id]/page";
import ProfileReports from "./pages-app/profile/reports/page";
import NotFound from "./pages-app/not-found";

function ProfileRoutes(): React.ReactElement {
  return (
    <AuthGuard>
      <ProfileLayout>
        <Switch>
          <Route exact path="/profile" component={ProfileDashboard} />
          <Route exact path="/profile/edit" component={ProfileEdit} />
          <Route exact path="/profile/favorites" component={ProfileFavorites} />
          <Route exact path="/profile/watch-list" component={ProfileWatchList} />
          <Route exact path="/profile/devices" component={ProfileDevices} />
          <Route exact path="/profile/wallet" component={ProfileWallet} />
          <Route exact path="/profile/wallet/:id" component={ProfileWalletDetail} />
          <Route exact path="/profile/subscription" component={ProfileSubscription} />
          <Route exact path="/profile/subscription/pay" component={ProfileSubscriptionPay} />
          <Route exact path="/profile/subscription/:id" component={ProfileSubscriptionDetail} />
          <Route exact path="/profile/lists" component={ProfileLists} />
          <Route exact path="/profile/lists/create" component={ProfileListsCreate} />
          <Route exact path="/profile/lists/:id/edit" component={ProfileListEdit} />
          <Route exact path="/profile/lists/:id" component={ProfileListDetail} />
          <Route exact path="/profile/tickets" component={ProfileTickets} />
          <Route exact path="/profile/tickets/create" component={ProfileTicketsCreate} />
          <Route exact path="/profile/tickets/:id" component={ProfileTicketDetail} />
          <Route exact path="/profile/reports" component={ProfileReports} />
          <Redirect to="/404" />
        </Switch>
      </ProfileLayout>
    </AuthGuard>
  );
}

function AuthRoutes(): React.ReactElement {
  return (
    <AuthLayout>
      <Switch>
        <Route exact path="/auth/forgot-password" component={ForgotPasswordPage} />
        <Route exact path="/auth" component={AuthPage} />
      </Switch>
    </AuthLayout>
  );
}

export default function AppRoutes(): React.ReactElement {
  return (
    <BrowserRouter>
      <AppShell>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/search" component={SearchPage} />
          <Route exact path="/movies" component={MoviesArchivePage} />
          <Route exact path="/series" component={SeriesArchivePage} />
          <Route exact path="/genre/:slug" component={GenreArchivePage} />
          <Route exact path="/country/:slug" component={CountryArchivePage} />
          <Route exact path="/language/:slug" component={LanguageArchivePage} />
          <Route exact path="/network/:slug" component={NetworkArchivePage} />
          <Route exact path="/release/:slug" component={ReleaseArchivePage} />
          <Route exact path="/actors" component={ActorsPage} />
          <Route exact path="/actors/:slug" component={ActorDetailPage} />
          <Route exact path="/directors" component={DirectorsPage} />
          <Route exact path="/directors/:slug" component={DirectorDetailPage} />
          <Route exact path="/lists" component={ListsPage} />
          <Route exact path="/lists/:id" component={ListDetailPage} />
          <Route path="/auth" component={AuthRoutes} />
          <Route exact path="/player/:id" component={PlayerPage} />
          <Route exact path="/game/:id" component={GamePage} />
          <Route exact path="/competition">
            <AuthGuard>
              <CompetitionPage />
            </AuthGuard>
          </Route>
          <Route path="/profile" component={ProfileRoutes} />
          <Route exact path="/404" component={NotFound} />
          <Route exact path="/:type/:id/:slug/" component={MovieDetailPage} />
          <Route exact path="/:type/:id/:slug" component={MovieDetailPage} />
          <Route component={NotFound} />
        </Switch>
      </AppShell>
    </BrowserRouter>
  );
}
